/**
 * L'ambito di un'entità (SPEC-026 §2): «Borsa» o «Crypto». Le regole che lo
 * calcolano stanno nel backend (`core/asset-domain.ts`); il frontend lo riceve
 * già deciso nei DTO (`domain` / `domains`) e qui tiene solo il tipo e le
 * etichette, condivise dal badge e da chiunque debba scriverne il nome.
 */

export type AssetDomain = 'stock' | 'crypto';

export const ASSET_DOMAIN_LABELS: Record<AssetDomain, string> = {
  stock: 'Borsa',
  crypto: 'Crypto',
};
